/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ShipmentState } from "./ShipmentState";
import {
  ShipmentStateFromJSON,
  ShipmentStateFromJSONTyped,
  ShipmentStateToJSON,
  ShipmentStateToJSONTyped,
} from "./ShipmentState";
import type { InvoiceAuditProblemResolutionType } from "./InvoiceAuditProblemResolutionType";
import {
  InvoiceAuditProblemResolutionTypeFromJSON,
  InvoiceAuditProblemResolutionTypeFromJSONTyped,
  InvoiceAuditProblemResolutionTypeToJSON,
  InvoiceAuditProblemResolutionTypeToJSONTyped,
} from "./InvoiceAuditProblemResolutionType";
import type { InvoiceAuditProblemFault } from "./InvoiceAuditProblemFault";
import {
  InvoiceAuditProblemFaultFromJSON,
  InvoiceAuditProblemFaultFromJSONTyped,
  InvoiceAuditProblemFaultToJSON,
  InvoiceAuditProblemFaultToJSONTyped,
} from "./InvoiceAuditProblemFault";
import type { GeoFilter } from "./GeoFilter";
import {
  GeoFilterFromJSON,
  GeoFilterFromJSONTyped,
  GeoFilterToJSON,
  GeoFilterToJSONTyped,
} from "./GeoFilter";
import type { InvoiceAuditProblemResolutionState } from "./InvoiceAuditProblemResolutionState";
import {
  InvoiceAuditProblemResolutionStateFromJSON,
  InvoiceAuditProblemResolutionStateFromJSONTyped,
  InvoiceAuditProblemResolutionStateToJSON,
  InvoiceAuditProblemResolutionStateToJSONTyped,
} from "./InvoiceAuditProblemResolutionState";
import type { InvoiceAuditProblemType } from "./InvoiceAuditProblemType";
import {
  InvoiceAuditProblemTypeFromJSON,
  InvoiceAuditProblemTypeFromJSONTyped,
  InvoiceAuditProblemTypeToJSON,
  InvoiceAuditProblemTypeToJSONTyped,
} from "./InvoiceAuditProblemType";
import type { HubbleShipmentFiltersQueryBookingStatus } from "./HubbleShipmentFiltersQueryBookingStatus";
import {
  HubbleShipmentFiltersQueryBookingStatusFromJSON,
  HubbleShipmentFiltersQueryBookingStatusFromJSONTyped,
  HubbleShipmentFiltersQueryBookingStatusToJSON,
  HubbleShipmentFiltersQueryBookingStatusToJSONTyped,
} from "./HubbleShipmentFiltersQueryBookingStatus";
import type { QuoteFilterType } from "./QuoteFilterType";
import {
  QuoteFilterTypeFromJSON,
  QuoteFilterTypeFromJSONTyped,
  QuoteFilterTypeToJSON,
  QuoteFilterTypeToJSONTyped,
} from "./QuoteFilterType";
import type { Source } from "./Source";
import {
  SourceFromJSON,
  SourceFromJSONTyped,
  SourceToJSON,
  SourceToJSONTyped,
} from "./Source";

/**
 *
 * @export
 * @interface HubbleShipmentFiltersQuery
 */
export interface HubbleShipmentFiltersQuery {
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  freeTextQuery: string;
  /**
   *
   * @type {HubbleShipmentFiltersQueryBookingStatus}
   * @memberof HubbleShipmentFiltersQuery
   */
  bookingStatus: HubbleShipmentFiltersQueryBookingStatus;
  /**
   *
   * @type {ShipmentState}
   * @memberof HubbleShipmentFiltersQuery
   */
  shipmentState?: ShipmentState | null;
  /**
   *
   * @type {QuoteFilterType}
   * @memberof HubbleShipmentFiltersQuery
   */
  quoteFilter?: QuoteFilterType | null;
  /**
   *
   * @type {LocalDate}
   * @memberof HubbleShipmentFiltersQuery
   */
  startDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof HubbleShipmentFiltersQuery
   */
  endDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof HubbleShipmentFiltersQuery
   */
  bookedStartDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof HubbleShipmentFiltersQuery
   */
  bookedEndDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupStartDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupEndDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  companyId?: string | null;
  /**
   *
   * @type {LocalDate}
   * @memberof HubbleShipmentFiltersQuery
   */
  companyFirstQuotedDateStartDate?: LocalDate | null;
  /**
   *
   * @type {LocalDate}
   * @memberof HubbleShipmentFiltersQuery
   */
  companyFirstQuotedDateEndDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  companyShipmentFrequency?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof HubbleShipmentFiltersQuery
   */
  companyLabels?: Array<string> | null;
  /**
   *
   * @type {GeoFilter}
   * @memberof HubbleShipmentFiltersQuery
   */
  geoFilter?: GeoFilter | null;
  /**
   *
   * @type {Array<string>}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupLocationFilterIdentifiers?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupCity?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupPostalCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupLocationType?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupDistributionWarehouseBrand?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof HubbleShipmentFiltersQuery
   */
  deliveryLocationFilterIdentifiers?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  deliveryCity?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  deliveryPostalCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  deliveryLocationType?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  deliveryDistributionWarehouseBrand?: string | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  minimumShipmentWeight?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  maximumShipmentWeight?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  minimumNumberHandlingUnits?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  maximumNumberHandlingUnits?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  minimumVolume?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  maximumVolume?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  minimumStandardDryVanLinearFeet?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  maximumStandardDryVanLinearFeet?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  minimumDensity?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  maximumDensity?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  minimumLongestDimensionInch?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  maximumLongestDimensionInch?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  hasStackableItems?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  invoiceAuditEverOpened?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  invoiceAuditCurrentlyOpen?: boolean | null;
  /**
   *
   * @type {Array<InvoiceAuditProblemType>}
   * @memberof HubbleShipmentFiltersQuery
   */
  invoiceAuditType?: Array<InvoiceAuditProblemType> | null;
  /**
   *
   * @type {Array<InvoiceAuditProblemFault>}
   * @memberof HubbleShipmentFiltersQuery
   */
  invoiceAuditProblemFault?: Array<InvoiceAuditProblemFault> | null;
  /**
   *
   * @type {Array<InvoiceAuditProblemResolutionType>}
   * @memberof HubbleShipmentFiltersQuery
   */
  invoiceAuditResolutionType?: Array<InvoiceAuditProblemResolutionType> | null;
  /**
   *
   * @type {Array<InvoiceAuditProblemResolutionState>}
   * @memberof HubbleShipmentFiltersQuery
   */
  invoiceAuditResolutionState?: Array<InvoiceAuditProblemResolutionState> | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  bookedCarrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  bookedCarrierServiceIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  lowestRateCarrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  hadQuotesFromCarrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  hadQuotesFromCarrierServiceIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  hasNoQuotesFromCarrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  inCarrierCoverageAreaCarrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  hadCustomerSpecificPricingQuotesFromCarrierIdentifier?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupLiftGateRequired?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  deliveryLiftGateRequired?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  pickupInsideRequired?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  deliveryInsideRequired?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  dangerous?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  protectFromFreezingRequired?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  deliveryAppointmentRequired?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  shipmentRequestedInsurance?: boolean | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  minInsuranceAmount?: number | null;
  /**
   *
   * @type {number}
   * @memberof HubbleShipmentFiltersQuery
   */
  maxInsuranceAmount?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  shipmentEverHadClaim?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  shipmentCurrentlyHasOpenClaim?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof HubbleShipmentFiltersQuery
   */
  starredByEmail?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleShipmentFiltersQuery
   */
  automaticallyFetchTrackingUpdates?: boolean | null;
  /**
   *
   * @type {Source}
   * @memberof HubbleShipmentFiltersQuery
   */
  source?: Source | null;
}

/**
 * Check if a given object implements the HubbleShipmentFiltersQuery interface.
 */
export function instanceOfHubbleShipmentFiltersQuery(
  value: object,
): value is HubbleShipmentFiltersQuery {
  if (!("freeTextQuery" in value) || value["freeTextQuery"] === undefined)
    return false;
  if (!("bookingStatus" in value) || value["bookingStatus"] === undefined)
    return false;
  return true;
}

export function HubbleShipmentFiltersQueryFromJSON(
  json: any,
): HubbleShipmentFiltersQuery {
  return HubbleShipmentFiltersQueryFromJSONTyped(json, false);
}

export function HubbleShipmentFiltersQueryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HubbleShipmentFiltersQuery {
  if (json == null) {
    return json;
  }
  return {
    freeTextQuery: json["freeTextQuery"],
    bookingStatus: HubbleShipmentFiltersQueryBookingStatusFromJSON(
      json["bookingStatus"],
    ),
    shipmentState:
      json["shipmentState"] == null
        ? undefined
        : ShipmentStateFromJSON(json["shipmentState"]),
    quoteFilter:
      json["quoteFilter"] == null
        ? undefined
        : QuoteFilterTypeFromJSON(json["quoteFilter"]),
    startDate: json["startDate"] == null ? undefined : json["startDate"],
    endDate: json["endDate"] == null ? undefined : json["endDate"],
    bookedStartDate:
      json["bookedStartDate"] == null ? undefined : json["bookedStartDate"],
    bookedEndDate:
      json["bookedEndDate"] == null ? undefined : json["bookedEndDate"],
    pickupStartDate:
      json["pickupStartDate"] == null ? undefined : json["pickupStartDate"],
    pickupEndDate:
      json["pickupEndDate"] == null ? undefined : json["pickupEndDate"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    companyFirstQuotedDateStartDate:
      json["companyFirstQuotedDateStartDate"] == null
        ? undefined
        : json["companyFirstQuotedDateStartDate"],
    companyFirstQuotedDateEndDate:
      json["companyFirstQuotedDateEndDate"] == null
        ? undefined
        : json["companyFirstQuotedDateEndDate"],
    companyShipmentFrequency:
      json["companyShipmentFrequency"] == null
        ? undefined
        : json["companyShipmentFrequency"],
    companyLabels:
      json["companyLabels"] == null ? undefined : json["companyLabels"],
    geoFilter:
      json["geoFilter"] == null
        ? undefined
        : GeoFilterFromJSON(json["geoFilter"]),
    pickupLocationFilterIdentifiers:
      json["pickupLocationFilterIdentifiers"] == null
        ? undefined
        : json["pickupLocationFilterIdentifiers"],
    pickupCity: json["pickupCity"] == null ? undefined : json["pickupCity"],
    pickupPostalCode:
      json["pickupPostalCode"] == null ? undefined : json["pickupPostalCode"],
    pickupLocationType:
      json["pickupLocationType"] == null
        ? undefined
        : json["pickupLocationType"],
    pickupDistributionWarehouseBrand:
      json["pickupDistributionWarehouseBrand"] == null
        ? undefined
        : json["pickupDistributionWarehouseBrand"],
    deliveryLocationFilterIdentifiers:
      json["deliveryLocationFilterIdentifiers"] == null
        ? undefined
        : json["deliveryLocationFilterIdentifiers"],
    deliveryCity:
      json["deliveryCity"] == null ? undefined : json["deliveryCity"],
    deliveryPostalCode:
      json["deliveryPostalCode"] == null
        ? undefined
        : json["deliveryPostalCode"],
    deliveryLocationType:
      json["deliveryLocationType"] == null
        ? undefined
        : json["deliveryLocationType"],
    deliveryDistributionWarehouseBrand:
      json["deliveryDistributionWarehouseBrand"] == null
        ? undefined
        : json["deliveryDistributionWarehouseBrand"],
    minimumShipmentWeight:
      json["minimumShipmentWeight"] == null
        ? undefined
        : json["minimumShipmentWeight"],
    maximumShipmentWeight:
      json["maximumShipmentWeight"] == null
        ? undefined
        : json["maximumShipmentWeight"],
    minimumNumberHandlingUnits:
      json["minimumNumberHandlingUnits"] == null
        ? undefined
        : json["minimumNumberHandlingUnits"],
    maximumNumberHandlingUnits:
      json["maximumNumberHandlingUnits"] == null
        ? undefined
        : json["maximumNumberHandlingUnits"],
    minimumVolume:
      json["minimumVolume"] == null ? undefined : json["minimumVolume"],
    maximumVolume:
      json["maximumVolume"] == null ? undefined : json["maximumVolume"],
    minimumStandardDryVanLinearFeet:
      json["minimumStandardDryVanLinearFeet"] == null
        ? undefined
        : json["minimumStandardDryVanLinearFeet"],
    maximumStandardDryVanLinearFeet:
      json["maximumStandardDryVanLinearFeet"] == null
        ? undefined
        : json["maximumStandardDryVanLinearFeet"],
    minimumDensity:
      json["minimumDensity"] == null ? undefined : json["minimumDensity"],
    maximumDensity:
      json["maximumDensity"] == null ? undefined : json["maximumDensity"],
    minimumLongestDimensionInch:
      json["minimumLongestDimensionInch"] == null
        ? undefined
        : json["minimumLongestDimensionInch"],
    maximumLongestDimensionInch:
      json["maximumLongestDimensionInch"] == null
        ? undefined
        : json["maximumLongestDimensionInch"],
    hasStackableItems:
      json["hasStackableItems"] == null ? undefined : json["hasStackableItems"],
    invoiceAuditEverOpened:
      json["invoiceAuditEverOpened"] == null
        ? undefined
        : json["invoiceAuditEverOpened"],
    invoiceAuditCurrentlyOpen:
      json["invoiceAuditCurrentlyOpen"] == null
        ? undefined
        : json["invoiceAuditCurrentlyOpen"],
    invoiceAuditType:
      json["invoiceAuditType"] == null
        ? undefined
        : (json["invoiceAuditType"] as Array<any>).map(
            InvoiceAuditProblemTypeFromJSON,
          ),
    invoiceAuditProblemFault:
      json["invoiceAuditProblemFault"] == null
        ? undefined
        : (json["invoiceAuditProblemFault"] as Array<any>).map(
            InvoiceAuditProblemFaultFromJSON,
          ),
    invoiceAuditResolutionType:
      json["invoiceAuditResolutionType"] == null
        ? undefined
        : (json["invoiceAuditResolutionType"] as Array<any>).map(
            InvoiceAuditProblemResolutionTypeFromJSON,
          ),
    invoiceAuditResolutionState:
      json["invoiceAuditResolutionState"] == null
        ? undefined
        : (json["invoiceAuditResolutionState"] as Array<any>).map(
            InvoiceAuditProblemResolutionStateFromJSON,
          ),
    bookedCarrierIdentifier:
      json["bookedCarrierIdentifier"] == null
        ? undefined
        : json["bookedCarrierIdentifier"],
    bookedCarrierServiceIdentifier:
      json["bookedCarrierServiceIdentifier"] == null
        ? undefined
        : json["bookedCarrierServiceIdentifier"],
    lowestRateCarrierIdentifier:
      json["lowestRateCarrierIdentifier"] == null
        ? undefined
        : json["lowestRateCarrierIdentifier"],
    hadQuotesFromCarrierIdentifier:
      json["hadQuotesFromCarrierIdentifier"] == null
        ? undefined
        : json["hadQuotesFromCarrierIdentifier"],
    hadQuotesFromCarrierServiceIdentifier:
      json["hadQuotesFromCarrierServiceIdentifier"] == null
        ? undefined
        : json["hadQuotesFromCarrierServiceIdentifier"],
    hasNoQuotesFromCarrierIdentifier:
      json["hasNoQuotesFromCarrierIdentifier"] == null
        ? undefined
        : json["hasNoQuotesFromCarrierIdentifier"],
    inCarrierCoverageAreaCarrierIdentifier:
      json["inCarrierCoverageAreaCarrierIdentifier"] == null
        ? undefined
        : json["inCarrierCoverageAreaCarrierIdentifier"],
    hadCustomerSpecificPricingQuotesFromCarrierIdentifier:
      json["hadCustomerSpecificPricingQuotesFromCarrierIdentifier"] == null
        ? undefined
        : json["hadCustomerSpecificPricingQuotesFromCarrierIdentifier"],
    pickupLiftGateRequired:
      json["pickupLiftGateRequired"] == null
        ? undefined
        : json["pickupLiftGateRequired"],
    deliveryLiftGateRequired:
      json["deliveryLiftGateRequired"] == null
        ? undefined
        : json["deliveryLiftGateRequired"],
    pickupInsideRequired:
      json["pickupInsideRequired"] == null
        ? undefined
        : json["pickupInsideRequired"],
    deliveryInsideRequired:
      json["deliveryInsideRequired"] == null
        ? undefined
        : json["deliveryInsideRequired"],
    dangerous: json["dangerous"] == null ? undefined : json["dangerous"],
    protectFromFreezingRequired:
      json["protectFromFreezingRequired"] == null
        ? undefined
        : json["protectFromFreezingRequired"],
    deliveryAppointmentRequired:
      json["deliveryAppointmentRequired"] == null
        ? undefined
        : json["deliveryAppointmentRequired"],
    shipmentRequestedInsurance:
      json["shipmentRequestedInsurance"] == null
        ? undefined
        : json["shipmentRequestedInsurance"],
    minInsuranceAmount:
      json["minInsuranceAmount"] == null
        ? undefined
        : json["minInsuranceAmount"],
    maxInsuranceAmount:
      json["maxInsuranceAmount"] == null
        ? undefined
        : json["maxInsuranceAmount"],
    shipmentEverHadClaim:
      json["shipmentEverHadClaim"] == null
        ? undefined
        : json["shipmentEverHadClaim"],
    shipmentCurrentlyHasOpenClaim:
      json["shipmentCurrentlyHasOpenClaim"] == null
        ? undefined
        : json["shipmentCurrentlyHasOpenClaim"],
    starredByEmail:
      json["starredByEmail"] == null ? undefined : json["starredByEmail"],
    automaticallyFetchTrackingUpdates:
      json["automaticallyFetchTrackingUpdates"] == null
        ? undefined
        : json["automaticallyFetchTrackingUpdates"],
    source: json["source"] == null ? undefined : SourceFromJSON(json["source"]),
  };
}

export function HubbleShipmentFiltersQueryToJSON(
  json: any,
): HubbleShipmentFiltersQuery {
  return HubbleShipmentFiltersQueryToJSONTyped(json, false);
}

export function HubbleShipmentFiltersQueryToJSONTyped(
  value?: HubbleShipmentFiltersQuery | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    freeTextQuery: value["freeTextQuery"],
    bookingStatus: HubbleShipmentFiltersQueryBookingStatusToJSON(
      value["bookingStatus"],
    ),
    shipmentState: ShipmentStateToJSON(value["shipmentState"]),
    quoteFilter: QuoteFilterTypeToJSON(value["quoteFilter"]),
    startDate: value["startDate"],
    endDate: value["endDate"],
    bookedStartDate: value["bookedStartDate"],
    bookedEndDate: value["bookedEndDate"],
    pickupStartDate: value["pickupStartDate"],
    pickupEndDate: value["pickupEndDate"],
    companyId: value["companyId"],
    companyFirstQuotedDateStartDate: value["companyFirstQuotedDateStartDate"],
    companyFirstQuotedDateEndDate: value["companyFirstQuotedDateEndDate"],
    companyShipmentFrequency: value["companyShipmentFrequency"],
    companyLabels: value["companyLabels"],
    geoFilter: GeoFilterToJSON(value["geoFilter"]),
    pickupLocationFilterIdentifiers: value["pickupLocationFilterIdentifiers"],
    pickupCity: value["pickupCity"],
    pickupPostalCode: value["pickupPostalCode"],
    pickupLocationType: value["pickupLocationType"],
    pickupDistributionWarehouseBrand: value["pickupDistributionWarehouseBrand"],
    deliveryLocationFilterIdentifiers:
      value["deliveryLocationFilterIdentifiers"],
    deliveryCity: value["deliveryCity"],
    deliveryPostalCode: value["deliveryPostalCode"],
    deliveryLocationType: value["deliveryLocationType"],
    deliveryDistributionWarehouseBrand:
      value["deliveryDistributionWarehouseBrand"],
    minimumShipmentWeight: value["minimumShipmentWeight"],
    maximumShipmentWeight: value["maximumShipmentWeight"],
    minimumNumberHandlingUnits: value["minimumNumberHandlingUnits"],
    maximumNumberHandlingUnits: value["maximumNumberHandlingUnits"],
    minimumVolume: value["minimumVolume"],
    maximumVolume: value["maximumVolume"],
    minimumStandardDryVanLinearFeet: value["minimumStandardDryVanLinearFeet"],
    maximumStandardDryVanLinearFeet: value["maximumStandardDryVanLinearFeet"],
    minimumDensity: value["minimumDensity"],
    maximumDensity: value["maximumDensity"],
    minimumLongestDimensionInch: value["minimumLongestDimensionInch"],
    maximumLongestDimensionInch: value["maximumLongestDimensionInch"],
    hasStackableItems: value["hasStackableItems"],
    invoiceAuditEverOpened: value["invoiceAuditEverOpened"],
    invoiceAuditCurrentlyOpen: value["invoiceAuditCurrentlyOpen"],
    invoiceAuditType:
      value["invoiceAuditType"] == null
        ? undefined
        : (value["invoiceAuditType"] as Array<any>).map(
            InvoiceAuditProblemTypeToJSON,
          ),
    invoiceAuditProblemFault:
      value["invoiceAuditProblemFault"] == null
        ? undefined
        : (value["invoiceAuditProblemFault"] as Array<any>).map(
            InvoiceAuditProblemFaultToJSON,
          ),
    invoiceAuditResolutionType:
      value["invoiceAuditResolutionType"] == null
        ? undefined
        : (value["invoiceAuditResolutionType"] as Array<any>).map(
            InvoiceAuditProblemResolutionTypeToJSON,
          ),
    invoiceAuditResolutionState:
      value["invoiceAuditResolutionState"] == null
        ? undefined
        : (value["invoiceAuditResolutionState"] as Array<any>).map(
            InvoiceAuditProblemResolutionStateToJSON,
          ),
    bookedCarrierIdentifier: value["bookedCarrierIdentifier"],
    bookedCarrierServiceIdentifier: value["bookedCarrierServiceIdentifier"],
    lowestRateCarrierIdentifier: value["lowestRateCarrierIdentifier"],
    hadQuotesFromCarrierIdentifier: value["hadQuotesFromCarrierIdentifier"],
    hadQuotesFromCarrierServiceIdentifier:
      value["hadQuotesFromCarrierServiceIdentifier"],
    hasNoQuotesFromCarrierIdentifier: value["hasNoQuotesFromCarrierIdentifier"],
    inCarrierCoverageAreaCarrierIdentifier:
      value["inCarrierCoverageAreaCarrierIdentifier"],
    hadCustomerSpecificPricingQuotesFromCarrierIdentifier:
      value["hadCustomerSpecificPricingQuotesFromCarrierIdentifier"],
    pickupLiftGateRequired: value["pickupLiftGateRequired"],
    deliveryLiftGateRequired: value["deliveryLiftGateRequired"],
    pickupInsideRequired: value["pickupInsideRequired"],
    deliveryInsideRequired: value["deliveryInsideRequired"],
    dangerous: value["dangerous"],
    protectFromFreezingRequired: value["protectFromFreezingRequired"],
    deliveryAppointmentRequired: value["deliveryAppointmentRequired"],
    shipmentRequestedInsurance: value["shipmentRequestedInsurance"],
    minInsuranceAmount: value["minInsuranceAmount"],
    maxInsuranceAmount: value["maxInsuranceAmount"],
    shipmentEverHadClaim: value["shipmentEverHadClaim"],
    shipmentCurrentlyHasOpenClaim: value["shipmentCurrentlyHasOpenClaim"],
    starredByEmail: value["starredByEmail"],
    automaticallyFetchTrackingUpdates:
      value["automaticallyFetchTrackingUpdates"],
    source: SourceToJSON(value["source"]),
  };
}
